import { handleActions } from 'redux-actions'
import * as type from './type'
import createUUID from '../../../../util/create-uuid'
import { DEFAULT_DESIGN_TEMPLATE } from './const'


export const initialState = {
    emailTemplateList: [],
    emailTemplateAttachmentList: [],
    userSelection: {
        processName: null,
        emailTemplateId: null,
        locale: 'de_DE',
    },
    fetching: false,
    error: null,
    hasChanged: false,
    emailTemplate: null,
    processMacroList: {},
}


export default handleActions({
    [type.FIND_EMAIL_TEMPLATE_LIST_REQUEST]: (state, action) => {
        return {
            ...state,
            error: null,
            fetching: true,
        }
    },
    [type.FIND_EMAIL_TEMPLATE_LIST_SUCCESS]: (state, action) => {
        const { emailTemplateList } = action.payload
        return {
            ...state,
            emailTemplateList,
            fetching: false,
        }
    },
    [type.FIND_EMAIL_TEMPLATE_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },
    [type.CHANGE_PROCESS]: (state, action) => {
        const { value } = action.payload
        return {
            ...state,
            userSelection: {
                ...state.userSelection,
                processName: value,
                templateId: null,
            },
            emailTemplate: null,
        }
    },
    [type.CHANGE_LOCALE]: (state, action) => {
        const { locale } = action.payload
        return {
            ...state,
            userSelection: {
                ...state.userSelection,
                locale,
            },
        }
    },
    [type.FIND_EMAIL_TEMPLATE_BY_ID_REQUEST]: (state, action) => {
        const { emailTemplateId } = action.payload
        return {
            ...state,
            userSelection: {
                ...state.userSelection,
                emailTemplateId,
            },
            fetching: true,
            error: null,
            emailTemplate: null,
        }
    },
    [type.FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS]: (state, action) => {
        const { emailTemplate } = action.payload
        return {
            ...state,
            fetching: false,
            emailTemplate,
        }
    },
    [type.FIND_EMAIL_TEMPLATE_BY_ID_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_EMAIL_TEMPLATE_VARIANT]: (state, action) => {
        const { localId, name, value } = action.payload
        return {
            ...state,
            emailTemplate: {
                ...state.emailTemplate,
                templateVariantList: state.emailTemplate.templateVariantList.map(variant => {
                    return variant.localId !== localId ? variant : {
                        ...variant,
                        [name]: value,
                    }
                }),
            },
        }
    },
    [type.CREATE_EMAIL_TEMPLATE_VARIANT]: (state, action) => {
        if (!state.userSelection.emailTemplateId) {
            return state
        }
        return {
            ...state,
            emailTemplate: {
                ...state.emailTemplate,
                templateVariantList: [
                    ...state.emailTemplate.templateVariantList,
                    {
                        locale: state.userSelection.locale,
                        localId: createUUID(),
                        templateId: state.userSelection.emailTemplateId,
                        designTemplateId: DEFAULT_DESIGN_TEMPLATE,
                        probability: 0,
                    },
                ],
            },
        }
    },
    [type.SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST]: (state, action) => {
        return {
            ...state,
            error: null,
            fetching: true,
        }
    },
    [type.SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS]: (state, action) => {
        const { localId, emailTemplateVariant } = action.payload

        return {
            ...state,
            emailTemplate: {
                ...state.emailTemplate,
                templateVariantList: state.emailTemplate.templateVariantList.map(variant => {
                    return variant.localId === localId ? emailTemplateVariant : variant
                }),
            },
            fetching: false,
        }
    },
    [type.SAVE_EMAIL_TEMPLATE_VARIANT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },
    [type.DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST]: (state, action) => {
        const { localId } = action.payload
        return {
            ...state,
            emailTemplate: {
                ...state.emailTemplate,
                templateVariantList: state.emailTemplate.templateVariantList.filter(variant => {
                    return variant.localId !== localId
                }),
            },
            error: null,
            fetching: true,
        }
    },
    [type.DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS]: (state, action) => {
        return {
            ...state,
            error: null,
            fetching: false,
        }
    },
    [type.DELETE_EMAIL_TEMPLATE_VARIANT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },
    [type.GET_PROCESS_MACRO_LIST_REQUEST]: (state, action) => {
        return {
            ...state,
            error: null,
            fetching: true,
        }
    },
    [type.GET_PROCESS_MACRO_LIST_SUCCESS]: (state, action) => {
        const { processName, emailMacroList } = action.payload
        return {
            ...state,
            fetching: false,
            processMacroList: {
                ...state.processMacroList,
                [processName]: emailMacroList,
            },
        }
    },
    [type.GET_PROCESS_MACRO_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/email/state/manage/reducer.js